import { PropRefProps } from "lib/utils/props";
import { forwardRef, useMemo } from "react";

export type CardProps = Omit<React.HTMLProps<HTMLAnchorElement>, "onClick"> &
    PropRefProps & {
        onClick?: React.MouseEventHandler<HTMLAnchorElement>;
    };

export type CardTitleProps = React.HTMLProps<HTMLDivElement>;

const CardTitleRenderFn = ({ children, className = "" }: CardTitleProps) => {
    return (
        <>
            <div className={`text-h4 flex h-5  w-full items-center ${className}`}>{children}</div>
            <hr className="w-full border border-b border-black60" />
        </>
    );
};

export type CardContentProps = React.HTMLProps<HTMLDivElement>;

const CardContentRenderFn = ({ children, className = "" }: CardContentProps) => {
    return (
        <div className={`text-h5 flex w-full flex-col items-center justify-start  ${className}`}>
            {children}
        </div>
    );
};

const CardRenderFn = forwardRef(
    ({ children, className = "", onClick, propRef, disabled, ...otherProps }: CardProps, forwardedRef) => {
        const ref = forwardedRef || propRef;
        const clickProps = useMemo(() => {
            const props = {} as React.HTMLProps<HTMLAnchorElement>;
            if (onClick) {
                props.role = "button";
                props.onClick = disabled ? undefined : onClick;
            }
            return props;
        }, [onClick, disabled]);
        const clickClassname = onClick ? "cursor-pointer" : "";
        return (
            <a
                className={`flex w-Card min-w-Card flex-col items-center justify-start space-y-3 rounded-r10 bg-black80 p-4 ${clickClassname} ${disabled && "cursor-not-allowed pointer-events-none opacity-50"} ${className}`}
                {...clickProps}
                ref={ref as React.RefObject<HTMLAnchorElement>}
                {...otherProps}
                aria-disabled={disabled}
            >
                {children}
            </a>
        );
    }
);

const Card = Object.assign(CardRenderFn, {
    Title: CardTitleRenderFn,
    Content: CardContentRenderFn,
});

export default Card;
